import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { ErrorsService } from '../../utils/services/errors.service';

@Injectable()
export class OrganizationalReportService {

  DateStatus: any;
  DateStatusSubject = new BehaviorSubject<any>(this.DateStatus);

  public subject = new Subject<any>();
  constructor(private httpService: HttpService,
    private errorsService: ErrorsService) { }

  /**API get method to request employee list*/
  getEmployee(empId): Observable<any> {
    return this.httpService.get(`employee/rm/report/${empId}`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API get method to search employee*/
  employeeSearch(empId, searchItem): Observable<any> {
    return this.httpService.get(`employee/rm/report/${empId}?search=${searchItem}`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API get method to get employee project detail*/
  getEmployeeProject(empId, startDate, endDate): Observable<any> {
    return this.httpService.get(`project/perUser/${empId}?startDate=${startDate}&endDate=${endDate}`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**function to check date status*/
  getDateStatus() {
    return this.DateStatusSubject.asObservable();
  }

  /**function to set date status*/
  setDateStatus(date) {
    this.DateStatusSubject.next(date);
  }

  /**function to handle API error data*/
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}




// WEBPACK FOOTER //
// ./src/app/rm/organizational-report/organizational-report.service.ts